import React, { useEffect, useState } from 'react'
import Layout from '../../layout/layout'
import AddFacility from './create-facility/facility-modal.component'
import styles from './facility-mamagement.module.css'
import FacilityView, {
  FacilityViewContext,
} from '../facility-info-view/facilityView'
import { CustomerViewContext } from '../../customers/actions/customer-info-view/customerView'
// import SpeedDials from '../facility-actions/index'
import FacilitiesList from '../facility-list/facilityList.component'

export default function FacilityManagement() {
  const [viewCustomer, setViewCustomer] = useState(false)
  const [viewHierarchy, setViewHierarchy] = useState(false)
  const [customerData, setCustomerData] = useState(false)
  const [show, setShow] = useState(false)
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [showDeviceBulk, setDeviceBulkShow] = useState(false)

  useEffect(() => {
    setViewCustomer(false)
  }, [])

  return (
    <Layout>
      <CustomerViewContext.Provider value={{ viewHierarchy, setViewHierarchy }}>
        <FacilityViewContext.Provider
          value={{
            viewCustomer,
            setViewCustomer,
            customerData,
            setCustomerData,
            openTemplateDialog,
            showDeviceBulk,
            setDeviceBulkShow,
            setOpenTemplateDialog,
            showConfirmDialog,
            setShowConfirmDialog,
          }}
        >
          <div className={styles.container}>
            {viewCustomer ? (
              <FacilityView />
            ) : (
              <>
                <FacilitiesList className={styles.list} />
                {/* <SpeedDials show={show} setShow={setShow} /> */}
                <AddFacility
                  show={show}
                  setShow={setShow}
                  className={styles.actions}
                />
              </>
            )}
          </div>
        </FacilityViewContext.Provider>
      </CustomerViewContext.Provider>
    </Layout>
  )
}
